/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
 
function GetOnTheVotersListInformation() {
  return ( 
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            {/* <DefaultInfoCard
              title="Voter Registration Month"
              description={
                <>
                  In honour of the International Day of Democracy, September 15, Elections Nova Scotia is raising awareness about the voter registration process.
                  <br />
                  <br />
                  While there is not currently an election pending, individuals may register to vote or update their electoral information at any time. Registering ahead of time ensures that voters are ready to participate in the electoral process whenever an election is called.
                </>
              }
            /> */}
            <DefaultInfoCard
              title="Chéticamp-Margarees-Pleasant Bay By-election"
              description={
                <>
                  A by-election is underway in the new electoral district of Chéticamp-Margarees-Pleasant Bay. Election day will be Tuesday, DATE XX, 2026. Voters in <a href="/ChéticampBy-election2026">Chéticamp-Margarees-Pleasant Bay</a> can find everything they need to know right here. 
                  <br />
                  </>
              }
            />
            <DefaultInfoCard
              //icon="info"
              title="How Do I Get on the Nova Scotia Election Voters List?"
              description={
                <>
                  <b><i>Getting on the List of Electors is easy! You can register online, or email between elections, and in person when you go to vote during an election.</i></b>
                  <br />
                  <br />
                  Elections Nova Scotia continually updates the voters list using many different methods. On an ongoing basis, Elections Nova Scotia selectively receives data from several sources including the Registry of Motor Vehicles, Vital Statistics, the Nova Scotia Civic Address File, Elections Canada, municipal elections and field work done by Returning Officers and Elections Nova Scotia staff.                  <br />
                  <b>
                    <i>Please note: </i>
                  </b>
                  The format of the information provided to Elections Nova Scotia from other organizations is not always compatible with the internal system. It is often best for electors with changes in their information to update directly with Elections Nova Scotia, rather than through a third party or another governmental organization. Contact Elections Nova Scotia about voter registration by emailing <a href="mailto:voter.registration@electionsnovascotia.ca">voter.registration@electionsnovascotia.ca</a> or calling 1-800-565-1504.                   <br />

                  {/* Of note, to be on the Nova Scotia voters list and vote in a provincial election, you must:
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Be a Canadian citizen.</li>
                    <li>Be at least 18 years old on election day.</li>
                    <li>Have lived in Nova Scotia for at least six months before the day an election is called.</li>
                  </ul> */}
                  <br />
                  <h3>
                    How to Register
                  </h3>
                  Voter may choose to register by:
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Using the Elections Canada Online Voter Registration Service</li>
                    <li>By mail using the attached <a href="files/GetOnTheVotersList/100_Elector Registration Form - Fillable.pdf">Voter Registration Form (fillable PDF)</a></li>
                    <li>Emailing <a href="mailto:voter.registration@electionsnovascotia.ca">voter.registration@electionsnovascotia.ca</a></li>
                    <li>Calling 1-800-565-1504 for assistance</li>
                  </ul>
                  {/* <h3>
                    Register by mail or email:
                  </h3>
                  You can choose to register by mail or e-mail by downloading the application form from our website and following the instructions. Send the form and a copy of your ID to Elections Nova Scotia by email <a href="mailto:elections@novascotia.ca">elections@novascotia.ca</a> or by mail to:
                  <b>
                    <br />
                    Manager, Information Systems and Technology
                    <br />
                    PO Box 2246
                    <br />
                    Halifax, NS  B3J 3C8 </b> */}

                  <br />
                  <h3>
                    Online Voter Registration Service:</h3>
                  You can register online to vote or update your address on the voters list using the service found at the link below. It will take you to the Elections Canada Online Voter Registration Service where information you provide may be used to register you with both Elections Canada and Elections Nova Scotia. Elections Nova Scotia selectively receives data from sources including Elections Canada for the purpose of updating the voters list.                  <br />
                  <b>Note: when registering via a third party, it is recommended that you follow up with Elections Nova Scotia directly to verify that your information is correct and up to date.</b>
                  <br /><br />
                  To register online through this service, you must provide a valid civic address in Nova Scotia. If you are registering for the first time, this service will ask you to provide your Nova Scotia driver&#39;s license number.

                  The following links will take you to Elections Canada’s Online Voter Registration Service.
                  {/* Please Note: Voter Information Cards will not be printed for the 42nd Provincial General Election in Nova Scotia. Once you register you can find a voting location near to you by entering your address in the <u><a className="trm-label trm-label-color" href="https://enstools.electionsnovascotia.ca/edinfo/Location.aspx">where do I vote</a></u> tool on Elections Nova Scotia’s website. */}
                  <ul style={{ paddingLeft: "40px" }}><br />
                    <li><u><a href="https://ereg.elections.ca/CWelcome.aspx?lang=e">Online Voter Registration Service (in English)</a></u></li>
                    <li><u><a href="https://ereg.elections.ca/CWelcome.aspx?lang=f">Service d’inscription en ligne de l&#39;électeur (en Français)</a></u></li>
                  </ul><br />
                  <h3>Register by Mail or Email</h3>
                  You can register by mail or email by completing a voter registration form and submitting it with the required documentation.
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="files/GetOnTheVotersList/100_Elector Registration Form - Fillable.pdf">Voter Registration Form (fillable PDF)</a></li>
                  </ul>
                  To register using the Voter Registration Form, you must provide a copy of valid ID with your current civic address in Nova Scotia, legal name, and proof of Canadian citizenship. Copies of this documentation must accompany your completed Voter Registration Form when submitted via mail or email.
                  <br />
                  <br/>
                  <b>
                    <i>Please note, </i>
                  </b>
                  only a copy of your ID is required. Please do not send original ID with your registration submission. You may make a copy of your valid ID by scanning it or taking an image using a smart device.
                  <br />
                  <br />
                  <h3>Mail your completed Voter Registration Form to:</h3>
                  Elections Nova Scotia <br />
                  Voter Registration <br />
                  PO Box 2246 <br />
                  Halifax, NS <br />
                  B3J 3C8 <br />
                  <br />
                  Email your completed Voter Registration Form: <a href="mailto:voter.registration@electionsnovascotia.ca">voter.registration@electionsnovascotia.ca</a>
                  <br />
                  <br />
                  <h3>Registration Support</h3>
                  Elections Nova Scotia wants to support all eligible Nova Scotian voters to get registered and be prepared for the next provincial general election. If you have any questions about registration or need help with the process, please reach out to us. You can contact Elections Nova Scotia about voter registration by emailing <a href="mailto:voter.registration@electionsnovascotia.ca">voter.registration@electionsnovascotia.ca</a> or calling 1-800-565-1504.
                  <br />
                  <br />
                  <h3>Voter Eligibility</h3>
                  To be on the Nova Scotia voters list and vote in a provincial election, you must:
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Be a Canadian citizen.</li>
                    <li>Be at least 18 years old on election day.</li>
                    <li>Have lived in Nova Scotia for at least six months before the day an election is called.</li>
                  </ul>
                  <br />

                  <h3>ID Requirements</h3>
                  Eligible voters need a valid form of ID with their current civic address and legal name to register. <a href="https://electionsnovascotia.ca/img/Acceptable%20Forms%20of%20Identification_1.jpg">Click here to view Acceptable Identification</a>
                  <br/>
                  Those without ID can still vote during an election by taking an oath attesting to their eligibility.
                    <br/>
                    <br/>
                  <h3>Why should I register to vote early?</h3>
                  Registered voters will receive a personalized Voter Information Card (VIC) during an election. VICs contain information about where and when to vote.
                  <br />
                  Although you do not need to have a VIC or be registered to vote, registering before an election makes voting quick and efficient.
                  <br />
                  <br />
                  <b>If you are not registered, you can still vote when an election is called</b>
                  <br/>
                  During an election, you can register when you go to vote in one of the following ways:
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Apply at the returning office in your electoral district. The returning officer will add your name to the list and also tell you what polling station you will vote at based on your civic address. <a href="https://enstools.electionsnovascotia.ca/edinfo/">Follow this link </a> to find your electoral district.</li>
                    <li>Apply at your voting location. The poll clerk will add your name to the list using an Elector Information Form. Be sure to bring appropriate ID.</li>
                  </ul>
                  {/* <h3>
                    During an election, you can:</h3>
                  <br />
                  <ol style={{ paddingLeft: "40px" }}>
                    <li>Apply at the returning office in your electoral district. The returning officer will add your name to the list and also tell you what polling station you will vote at based on your civic address. <u><a href="https://enstools.electionsnovascotia.ca/edinfo/">Follow this link</a></u> to find your electoral district.</li>
                    <li>Apply at your polling station. The poll clerk will add your name to the list using a Elector Information Form. Be sure to bring appropriate ID.</li></ol>
                  <br />
                  <h3>
                    ID Requirements</h3>
                  You will be asked to show ID to have your name on the list of electors (if you aren&#39;t already on it). Even if you have your Voter Information Card in hand, it&#39;s always a good idea to bring your proper and current ID to the polling station so there won&#39;t be any confusion or delay.
                  <br /><br />
                  <a
                    href="img/Acceptable Forms of Identification_1.jpg"
                  >
                    <i>Click here to view Acceptable Identification</i>
                  </a> */}
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default GetOnTheVotersListInformation;


